<template>
  <HomeIntro />
  <Features />
  <Testimonials />
  <Fqa />
</template>

<script>
import HomeIntro from "@/components/home/HomeIntro.vue";
import Features from "@/components/home/Features.vue";
import Testimonials from "@/components/home/Testimonials.vue";
import Fqa from "@/components/home/Fqa.vue";

export default {
  components: { HomeIntro, Features, Testimonials, Fqa },
  name: "Home",
};
</script>
